import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getTopic, incrementTopicViews } from '../firebase/topicsService';
import './TopicView.css';

function TopicView() {
  const { topicId } = useParams();
  const navigate = useNavigate();
  const [topic, setTopic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  // دالة لتحويل التاريخ الميلادي إلى هجري
  const formatHijriDate = (timestamp) => {
    if (!timestamp) return '-';
    
    try {
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
      
      // استخدام Intl.DateTimeFormat للحصول على التاريخ الهجري الدقيق
      const formatter = new Intl.DateTimeFormat('ar-SA-u-ca-islamic', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
      
      return formatter.format(date);
    } catch (error) {
      console.error('Error formatting Hijri date:', error);
      return '-';
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    loadTopic();
  }, [topicId]);

  const loadTopic = async () => {
    setLoading(true);
    try {
      const topicData = await getTopic(topicId);
      if (topicData) {
        setTopic(topicData);
        // زيادة عدد المشاهدات
        await incrementTopicViews(topicId);
      }
    } catch (error) {
      console.error('Error loading topic:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="topic-view">
        <div className="topic-container">
          <div className="loading">جاري تحميل الموضوع...</div>
        </div>
      </div>
    );
  }

  if (!topic) {
    return (
      <div className="topic-view">
        <div className="topic-container">
          <div className="not-found">
            <h2>الموضوع غير موجود</h2>
            <button className="back-btn" onClick={() => navigate('/scholars')}>
              العودة للمواضيع
            </button>
          </div>
        </div>
      </div>
    );
  }

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: topic.title,
        text: topic.content.substring(0, 100) + '...',
        url: window.location.href
      }).catch(err => console.log('Error sharing:', err));
    } else {
      navigator.clipboard.writeText(window.location.href);
      alert('تم نسخ الرابط!');
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="topic-view">
      <div className="topic-container">
        <button className="back-btn" onClick={() => navigate('/scholars')}>
          → العودة للمواضيع
        </button>

        <article className="topic-article">
          <header className="topic-header">
            <h1 className="topic-title">{topic.title}</h1>
            <div className="topic-meta">
              <span className="meta-item">
                <span className="meta-icon">📅</span>
                {formatHijriDate(topic.createdAt)}
              </span>
            </div>
          </header>

          <div className="topic-content">
            {topic.content && topic.content.split('\n\n').map((paragraph, index) => (
              <p key={index} className="content-paragraph">
                {paragraph}
              </p>
            ))}
          </div>

          <footer className="topic-footer">
            <button className="topic-share-btn" onClick={handleShare}>
              <span className="btn-icon">🔗</span>
              مشاركة الموضوع
            </button>
            <button className="topic-copy-link-btn" onClick={handleCopyLink} title="نسخ رابط الموضوع">
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                <path d="M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z"/>
              </svg>
              {copied ? 'تم النسخ ✓' : 'نسخ الرابط'}
            </button>
          </footer>
        </article>
      </div>
    </div>
  );
}

export default TopicView;
